import TikTokWrapper from "../components/socialglass/post_components/TikTokWrapper";
import TwitterWrapper from "../components/socialglass/post_components/TwitterWrapper";
import InstagramWrapper from "../components/socialglass/post_components/InstagramWrapper";
import YoutubeWrapper from "../components/socialglass/post_components/YoutubeWrapper";

const SocialMediaEmbed = ({
  platform,
  url,
  videoRef,
  type,
  caption,
  creatorName,
  downloaded_path,
  muted,
  onManualUnmute,
  onManualMute,
}) => {
  if (!url) return <p>Invalid URL</p>;

  const commonProps = {
    platform,
    url,
    type,
    caption,
    creatorName,
    downloaded_path,
    videoRef,
    muted,
    onManualUnmute,
    onManualMute,
  };

  switch (platform) {
    case "tiktok":
      return <TikTokWrapper {...commonProps} />;
    case "twitter":
      return (
        <TwitterWrapper
          {...commonProps}
          url={url.replace("x.com", "twitter.com")}
        />
      );
    case "instagram":
      return <InstagramWrapper {...commonProps} />;
    case "youtube":
      return <YoutubeWrapper {...commonProps} />;
    default:
      return <p>Unsupported platform</p>;
  }
};

export default SocialMediaEmbed;
